import request from '@/api/request'

/**
 * 学员列表
 *
 * @param {*} data
 * @return {*}
 */

 export const getListPage = params => {
  return request({
    url: 'admin/base/adm/appUserInfo/getListPage',
    method: 'get',
    params,
  })
}

// 添加学员
export const addAppUserInfo = data => {
  return request({
    url: 'admin/base/adm/appUserInfo/addAppUserInfo',
    method: 'post',
    data,
  })
}

// 编辑学员
export const saveUserData = data => {
  return request({
    url: 'admin/base/adm/appUserInfo/saveUserData',
    method: 'post',
    data,
  })
}

// 修改手机号
export const updateUserPhone = data => {
  return request({
    url: 'admin/base/adm/appUserInfo/updateUserPhone',
    method: 'post',
    data,
  })
}

// 重置密码
export const resetUserPwd = data => {
  return request({
    url: 'admin/base/adm/appUserInfo/updateAppUserInfo',
    method: 'post',
    data,
  })
}

// 微信解绑
export const unbindWechat = data => {
  return request({
    url: 'admin/base/adm/appUserInfo/unbindWechat',
    method: 'post',
    data,
  })
}


/**
 * 公司列表
 *
 * @param {*} data
 * @return {*}
 */

 export const getAvailableCompanyList = params => {
  return request({
    url: 'base/adm/company/getAvailableCompanyList',
    method: 'post',
    params,
  })
}

// 班级学员列表
export const userSkupage = data => {
  return request({
    url: 'product/adm/userSku/page',
    method: 'post',
    data,
    type:"json"
  })
}

// 落后提醒设置
export const updateValueByKey = data => {
  return request({
    url: 'base/adm/baseDictionary/updateValueByKey',
    method: 'post',
    data,
    type:"json"
  })
}

//落后提醒获取
export const getValueByKeyForOrder = params => {
  return request({
    url: 'base/adm/baseDictionary/getValueByKeyForOrder',
    method: 'get',
    params,
  })
}

// 分页查询协议
export const contractSignList = data => {
  return request({
    url: 'order/adm/contractSign/getListPage',
    method: 'post',
    data,
    type:"json"
  })
}

// 删除协议
export const delContractSign = data => {
  return request({
    url: 'order/app/order/delContractSign',
    method: 'post',
    data,
    type:"json"
  })
}


export const getPrivateImgUrl = (fileName) => {
  const data = {
    fileName: fileName
  }
  return request({
    url: '/admin/file/admin/personal/wholeUrl',
    data,
    method: 'post'
  })
}

// 调整考试次数
export const numOperateUpdate = data => {
  return request({
    url: 'product/adm/numOperateRecord/updateNum',
    method: 'post',
    data
  })
}

// 调整考试次数操作记录
export const numOperateRecordLisr = data => {
  return request({
    url: 'product/adm/numOperateRecord/getList',
    method: 'post',
    data
  })
}

/**
 * 人才库列表
 */

export const getTalentPoolListPage = data => {
  return request({
    url: 'base/adm/talentPool/getListPage',
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 人才库管理-获取配置交流账号
 */

export const getCommunicationConf = () => {
  return request({
    url: 'base/adm/talentPool/getCommunicationConf',
    method: 'get'
  })
}

/**
 * 人才库管理-配置交流账号
 */

export const updateCommunicationConf = data => {
  return request({
    url: 'base/adm/talentPool/updateCommunicationConf',
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 编辑人才库
 */

export const updateTalentPoolInfo = data => {
  return request({
    url: 'base/adm/talentPool/updateTalentPoolInfo',
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 人才库管理-修改记录
 */

export const gettalentPoolRecordListPage = data => {
  return request({
    url: 'base/adm/talentPoolRecord/getListPage',
    method: 'post',
    type: 'json',
    data
  })
}
